import { BUTTON_SIZE } from 'consts/enum';
import { ENGT_CHAT } from 'js/bot.model';
import { buttonOptions } from './button.model';
import './button.scss';

export class Button {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEventHandlers();
	}

	initData(props) {
		this.data = buttonOptions;
		this.setter({
			className: props.className,
			disabled: props.disabled,
			label: props.label,
			onClick: props.onClick,
			type: props.type,
			id: props.id,
			size: props.size,
			style: props.style,
			tabIndex: props.tabIndex,
			applyOnHover: props.applyOnHover,
			radius: props.radius,
			dataInteractiveField: props.dataInteractiveField,
			dataQa: props.dataQa,
			dataTrackingId: props.dataTrackingId,
		});
	}

	initWrapper() {
		const {
			id,
			label,
			type,
			className = '',
			style = '',
			disabled = false,
			size = BUTTON_SIZE.SMALL,
			tabIndex,
			radius = 8,
			dataInteractiveField,
			dataQa,
			dataTrackingId,
		} = this.data;
		const button = document.createElement('button');
		if (className) {
			button.classList.add(className);
		}
		button.classList.add('engt-button');
		button.classList.add(`engt-button-radius-${radius}`);
		button.classList.add(`engt-button-${type.toLowerCase()}`);
		if (tabIndex !== undefined) {
			button.setAttribute('tabindex', tabIndex);
		}
		if (id) button.id = id;
		if (style) button.style = style;
		if (dataInteractiveField) button.setAttribute('data-interactive-field', '');
		if (dataTrackingId) button.setAttribute('data-tracking-id', dataTrackingId);
		button.disabled = disabled;
		button.innerHTML = label;

		if (dataQa) {
			button.setAttribute('data-qa', dataQa);
		}
		this.html = button;
	}

	initEventHandlers() {
		const { onClick, applyOnHover, type } = this.data || {};

		if (typeof onClick !== 'string') {
			this.html.addEventListener('click', onClick);
			this.html.addEventListener('keydown', (e) => ENGT_CHAT.get('onEnterPress')(onClick));
		}
		if (applyOnHover) {
			this.html.addEventListener('mouseover', function (e) {
				this.classList.add(`engt-button-${type.toLowerCase()}-hover`);
			});
			this.html.addEventListener('mouseout', function (e) {
				this.classList.remove(`engt-button-${type.toLowerCase()}-hover`);
			});
		}
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
